import request from '../js/request'
// import SPDAPIURL from '@/utils/SPDGlobal/SPDAPIURL'
import { Message } from 'element-ui'

const SPDAPIURL = JSON.parse(localStorage.getItem('smturl'))



const createError = (code, resp) => {
  const err = new Error(resp.message)
  err.code = code
  return err
}

// 处理普通的返回结果
const handleRequest = ({ code, result, ...rest }) => {
  if (code === 1) {
    if (result instanceof Array && result.length === 0) {
      result = {
        heard: {},
        details: []
      }
    }
    return result
  } else {
    throw createError(status, rest)
  }
}

// 处理result只有一个值返的结果
const handleOnlyRequest = ({ code, result, ...rest }) => {
  if (code === 1) {
    return result
  } else {
    throw createError(status, rest)
  }
}

// 处理有分页的返回结果
const handlePageRequest = ({ code, result, count, ...rest }) => {
  if (code === 1) {
    return { result, count }
  } else {
    throw createError(status, rest)
  }
}

// 处理提交数据的返回结果
const handleSubmitRequest = ({ code, result, ...rest }) => {
  if (code === 1) {
    Message.success('请求成功')
    return result
  } else {
    throw createError(status, rest)
  }
}

export function createDb() {
  return {
    // 获取from和table数据
    async getdata(data, ApiUrl) {
      return handlePageRequest(await request({
        url: SPDAPIURL.CURRENTAPIUrl + ApiUrl,
        method: 'post',
        data
      }))
    },
    // 通过页面配置对象名获取页面的标题列表
    async gettableheaders(data) {
      return handleRequest(
        await request({
          url: SPDAPIURL.OSAPIUrl + 'api/Tsystem/GetPageConfigResultByObjectName?pagename=' + data,
          method: 'post',
          data
        }))
    },
    // 通过接口和行id获取数据
    async getformdata(btn, btndata) {
      return handleRequest(await request({
        url: SPDAPIURL.CURRENTAPIUrl + btn.apiurl + '?id=' + btndata.id,
        method: 'post',
        data: btndata
      }))
    },
    // 通过路径和行id获取数据
    async getdatabyurl(url, btndata) {
      return handleRequest(await request({
        url: url + '?id=' + btndata.id,
        method: 'post',
        data: btndata
      }))
    },
    // 通过数组获取配置
    async getconfigs(data) {
      console.log(SPDAPIURL.OSAPIUrl,"!!!!!!!!!!!!!")
      return handleRequest(await request({
        url: SPDAPIURL.OSAPIUrl + 'api/SysConfig/GetConfigByCodes',
        method: 'post',
        data
      }))
    },
    async getFormtData(api,data={}){
      return handleSubmitRequest(await request({
        url: api,
        method: 'post',
        data: data
      }))
    },
    async get(ApiUrl) {
      const result = {}
      await request({
        url: ApiUrl,
        method: 'post',
        data: {}
      }).then(res => {
        for (var key in res.result) {
          result[key] = res.result[key]
        }
      })
      return result
    },
    async post(api, data) {
      return handleOnlyRequest(await request({
        url: SPDAPIURL.CURRENTAPIUrl + api,
        method: 'post',
        data: data
      }))
    },
    // 提交数据的接口
    async submit(api, data) {
      return handleSubmitRequest(await request({
        url: SPDAPIURL.CURRENTAPIUrl + api,
        method: 'post',
        data: data
      }))
    },
    // 上传文件
    async upFile(api, data) {
      return handlePageRequest(await request({
        url: SPDAPIURL.CURRENTAPIUrl + api,
        method: 'post',
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
        }
      }))
    },
    // 未完成的接口(友好提示！！)
    nodo() {
      Message.info('此功能在建设中')
    }
  }
}
